import { Chip as ChipMui } from "@mui/material";
import cx from "classnames";
import "./Chip.css";

const Chip = (props) => {
    const {
        isSuccess, isWarning, isError, isInfo,
        children,
    } = props;

    return (
        <ChipMui
            label={children}
            className={cx(
                "chip",
                { "chip--success": isSuccess },
                { "chip--warning": isWarning },
                { "chip--verifying": isInfo },
                { "chip--error": isError },
            )}
        />
    );
};

export default Chip;
